import { Steps, message } from 'antd';
import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import './aside.scss';

const { Step } = Steps;

type Direction = 'horizontal' | 'vertical' | undefined;
type Size = 'default' | 'small' | undefined;

type Steptype = {
  [key: number]: boolean;
};

export const AsideComponent = () => {
  const { state, dispatch } = useFormContext();
  const [direction, setDirection] = useState('horizontal' as Direction);
  const [size, setSize] = useState('default' as Size);
  const [stepValidatedErros, serStepValidatedErros] = useState<Steptype>({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
  });

  function resize() {
    if (window.screen.width <= 576) {
      setDirection('horizontal');
      setSize('small');
    } else {
      setDirection('vertical');
      setSize('default');
    }
  }

  const setTitle = (step: number) => {
    switch (step) {
      case 0:
        return 'Datos del declarante';
      case 1:
        return 'Datos del conductor';
      case 2:
        return 'Antecedentes del siniestro';
      case 3:
        return 'Descripción del accidente';
      case 4:
        return 'Terceros involucrados';
      case 5:
        return 'Adjuntar documentos';
      default:
        break;
    }
  };

  useMemo(() => {
    window.addEventListener('resize', resize);
    resize();
  }, [null]);

  useEffect(() => {
    // console.log('useEffect Aside', stepValidatedErros);

    const lastValidStep = state?.step ?? 0;
    let copyObjectC = { ...stepValidatedErros };
    copyObjectC[lastValidStep] = true;

    serStepValidatedErros({ ...copyObjectC });

    window.scrollTo(0, 0);
  }, [state.step]);

  const moveStep = (step: number, updateControl: Steptype) => {
    serStepValidatedErros({ ...updateControl });
    dispatch({
      type: 'UPDATE_STEP',
      payload: step,
    });
    return;
  };

  const onChangeToStepsVertical = async (stepToJump: number, strictMode: boolean = true) => {
    const currentstep = state.step ?? 0;

    if (currentstep > 0 && stepToJump < currentstep) {
      dispatch({
        type: 'UPDATE_STEP',
        payload: stepToJump,
      });
      return;
    } else {
      const { elementForm } = state;
      elementForm?.submit();

      try {
        await elementForm?.validateFields();
      } catch (e) {}

      const errors = elementForm?.getFieldsError().filter((e) => {
        return !isEmpty(e.errors);
      });

      let copyObject: Steptype = { 0: false, 1: false, 2: false, 3: false, 4: false };
      if (errors?.length === 0) {
        copyObject = Object.assign({}, stepValidatedErros);
        copyObject[currentstep] = true;
      } else {
        copyObject = Object.assign({}, stepValidatedErros);
        copyObject[currentstep] = false;
      }

      console.log('errorNext: ', { errors, currentstep, stepToJump, copyObject });

      if (currentstep === 0 && stepToJump === 1 && copyObject[0] === true) {
        moveStep(stepToJump, copyObject);
      } else if ([0, 1].includes(currentstep) && stepToJump === 2 && copyObject[0] === true && copyObject[1] === true) {
        moveStep(stepToJump, copyObject);
      } else if ([0, 1, 2].includes(currentstep) && stepToJump === 3 && copyObject[0] === true && copyObject[1] === true && copyObject[2] === true) {
        moveStep(stepToJump, copyObject);
      } else if (
        [0, 1, 2, 3].includes(currentstep) &&
        stepToJump === 4 &&
        copyObject[0] === true &&
        copyObject[1] === true &&
        copyObject[2] === true &&
        copyObject[3] === true
      ) {
        moveStep(stepToJump, copyObject);
      } else if (
        [0, 1, 2, 3, 4].includes(currentstep) &&
        stepToJump === 5 &&
        copyObject[0] === true &&
        copyObject[1] === true &&
        copyObject[2] === true &&
        copyObject[3] === true &&
        copyObject[3] === true
      ) {
        moveStep(stepToJump, copyObject);
      } else {
        serStepValidatedErros({ ...copyObject });
        message.error('No puede avanzar a la siguiente sección sin completar la anterior');
      }
    }
  };

  return (
    <>
      {window.screen.width > 576 && (
        <div className="aside">
          <div className="steps_box">
            <Steps
              progressDot
              current={state.step}
              size={size}
              responsive={false}
              direction={direction}
              onChange={(value) => onChangeToStepsVertical(value, false)}
            >
              <Step title="Datos del declarante" description="" />
              <Step title="Datos del conductor" description="" />
              <Step title="Antecedentes del siniestro" description="" />
              <Step title="Descripción del accidente" description="" />
              <Step title="Terceros involucrados" description="" />
              <Step title="Adjuntar documentos" description="" />
            </Steps>
          </div>
        </div>
      )}

      {window.screen.width < 576 && (
        <div className="steps_box">
          <div>
            <h4>{state.step && state.step !== 0 ? setTitle(state?.step) : 'Datos del declante'}</h4>
          </div>
          <div className="steps">
            <div className={`circle circle_doing`}></div>
            <div className={`line ${state.step && state.step >= 1 ? 'line_done' : ''}`}></div>
            <div className={`circle ${state.step && state.step >= 1 ? 'circle_doing' : ''}`}></div>
            <div className={`line ${state.step && state.step >= 2 ? 'line_done' : ''}`}></div>
            <div className={`circle ${state.step && state.step >= 2 ? 'circle_doing' : ''}`}></div>
            <div className={`line ${state.step && state.step >= 3 ? 'line_done' : ''}`}></div>
            <div className={`circle ${state.step && state.step >= 3 ? 'circle_doing' : ''}`}></div>
            <div className={`line ${state.step && state.step >= 4 ? 'line_done' : ''}`}></div>
            <div className={`circle ${state.step && state.step >= 4 ? 'circle_doing' : ''}`}></div>
            <div className={`line ${state.step && state.step >= 5 ? 'line_done' : ''}`}></div>
            <div className={`circle ${state.step && state.step >= 5 ? 'circle_doing' : ''}`}></div>
          </div>
        </div>
      )}
      {/* {window.screen.width > 576 && (
        <div className="right-button">
          <div style={{}}>
            <button
              className="floating-button"
              onClick={() => {
                const step = state.step ?? 0;
                if (step > 0) {
                  onChangeToSteps(step - 1);
                }
              }}
            >
              <UpOutlined />
            </button>
          </div>
          <div
            style={{
              marginTop: '10px',
            }}
          >
            <button
              className="floating-button"
              onClick={() => {
                const step = state.step ?? 0;
                if (step < 5) {
                  onChangeToSteps(step + 1);
                }
              }}
            >
              <DownOutlined />
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};
